import React from 'react';
import { Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';

interface AutoSaveIndicatorProps {
  status: 'idle' | 'saving' | 'saved' | 'error';
  savedAt: Date | null;
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({ status, savedAt }) => {
  if (status === 'idle') return null;

  return (
    <div className="flex items-center gap-1.5 text-xs">
      {status === 'saving' && (
        <>
          <Loader2 className="w-3.5 h-3.5 text-gray-400 animate-spin" />
          <span className="text-gray-400">Saving...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <CheckCircle2 className="w-3.5 h-3.5 text-green-500" />
          <span className="text-green-600">
            Saved {savedAt ? formatTime(savedAt) : ''}
          </span>
        </>
      )}
      {status === 'error' && (
        <>
          <AlertTriangle className="w-3.5 h-3.5 text-red-500" />
          <span className="text-red-500">Save failed</span>
        </>
      )}
    </div>
  );
};

export default AutoSaveIndicator;
